import { View } from 'foundations-components/components/View';
import HeroBanner from './HeroBanner';
import NextStepSection from './NextStepSection';
import ResourcesSection from './ResourcesSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyOnboardingLandingPage = () => {
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(HeroBanner, {}), /*#__PURE__*/_jsx(NextStepSection, {}), /*#__PURE__*/_jsx(ResourcesSection, {})]
  });
};
export default AcademyOnboardingLandingPage;